module.exports = __webpack_public_path__ + "static/img/专利2.702dbdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/专利2.jpg
// module id = fsDP
// module chunks = 1